import { createSlice } from '@reduxjs/toolkit'

/**
 * The fullscreen loading bar.
 *
 * `loader` stays a className string, because that is what FullscreenLoader
 * consumes and nothing else needs to change.
 *
 * What changed at T-014: it is now backed by a COUNT of requests in flight.
 * Every API call dispatches show() then hide(), and once mount fetches run
 * concurrently the first response to arrive would otherwise call hide() and
 * take the bar away while five other requests were still running — so the
 * screen would look finished while it was still filling in.
 *
 * Counting means the bar goes up on the first request and comes down on the
 * last, which is what someone watching it expects it to mean.
 */
export const SettingSlice = createSlice({
    name: 'setting',
    initialState: {
        loader: 'd-none',
        pending: 0,
    },
    reducers: {
        show: (state) => {
            state.pending += 1
            state.loader = ''
        },
        hide: (state) => {
            // Never below zero. An unmatched hide() — an error path that calls
            // it twice, say — must not leave the counter negative, or the next
            // real request would fail to show the bar at all.
            state.pending = Math.max(0, state.pending - 1)
            state.loader = state.pending === 0 ? 'd-none' : ''
        },
    },
})

export const { show, hide } = SettingSlice.actions

export default SettingSlice.reducer
